export var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "error";
    MessageType["INFO"] = "info";
    MessageType["WARNING"] = "warning";
})(MessageType || (MessageType = {}));
